import { Metadata_StringCategory$reflection, Metadata_StringCategory } from "../../../../Shared/Shared.js";
import { class_type } from "../../../../fable_modules/fable-library.3.7.9/Reflection.js";

export class Tid extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "tid";
    }
}

export function Tid$reflection() {
    return class_type("Corpora.Bokselskap.MetadataCategories.Tid", void 0, Tid, Metadata_StringCategory$reflection());
}

export function Tid_$ctor_Z721C83C5(aName) {
    return new Tid(aName);
}

export class Title extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "title";
    }
}

export function Title$reflection() {
    return class_type("Corpora.Bokselskap.MetadataCategories.Title", void 0, Title, Metadata_StringCategory$reflection());
}

export function Title_$ctor_Z721C83C5(aName) {
    return new Title(aName);
}

export class Author extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "author";
    }
}

export function Author$reflection() {
    return class_type("Corpora.Bokselskap.MetadataCategories.Author", void 0, Author, Metadata_StringCategory$reflection());
}

export function Author_$ctor_Z721C83C5(aName) {
    return new Author(aName);
}

export class LangVariety extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "lang_variety";
    }
}

export function LangVariety$reflection() {
    return class_type("Corpora.Bokselskap.MetadataCategories.LangVariety", void 0, LangVariety, Metadata_StringCategory$reflection());
}

export function LangVariety_$ctor_Z721C83C5(aName) {
    return new LangVariety(aName);
}

export class Sex extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "sex";
    }
}

export function Sex$reflection() {
    return class_type("Corpora.Bokselskap.MetadataCategories.Sex", void 0, Sex, Metadata_StringCategory$reflection());
}

export function Sex_$ctor_Z721C83C5(aName) {
    return new Sex(aName);
}

export class Genre extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "genre";
    }
}

export function Genre$reflection() {
    return class_type("Corpora.Bokselskap.MetadataCategories.Genre", void 0, Genre, Metadata_StringCategory$reflection());
}

export function Genre_$ctor_Z721C83C5(aName) {
    return new Genre(aName);
}

export class FirstEdition extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "first_edition";
    }
}

export function FirstEdition$reflection() {
    return class_type("Corpora.Bokselskap.MetadataCategories.FirstEdition", void 0, FirstEdition, Metadata_StringCategory$reflection());
}

export function FirstEdition_$ctor_Z721C83C5(aName) {
    return new FirstEdition(aName);
}

export class EditionYear extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "edition_year";
    }
}

export function EditionYear$reflection() {
    return class_type("Corpora.Bokselskap.MetadataCategories.EditionYear", void 0, EditionYear, Metadata_StringCategory$reflection());
}

export function EditionYear_$ctor_Z721C83C5(aName) {
    return new EditionYear(aName);
}

export class Comments extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "comments";
    }
}

export function Comments$reflection() {
    return class_type("Corpora.Bokselskap.MetadataCategories.Comments", void 0, Comments, Metadata_StringCategory$reflection());
}

export function Comments_$ctor_Z721C83C5(aName) {
    return new Comments(aName);
}

